import { ConfigDocumentModel } from "models/ConfigDocumentModel";
import { createContext } from "react";

interface BoardTemplatesContextProps {
  results: ConfigDocumentModel[];
  validNames: string[];
  isLoading: boolean;
  isPanelOpen: boolean;
  openPanel: () => void;
  closePanel: () => void;
  upload: (file: File, language?: string) => Promise<void>;
  remove: (path: string) => Promise<void>;
  isUploading: boolean;
  deletingPath: string | null;
}

export const BoardTemplatesContext = createContext({} as BoardTemplatesContextProps);
